import type { BackgroundType } from "components/atoms/Button/Button";
import type { Background } from "components/molecules/HeaderStatusInfo/HeaderStatusInfo";

// Global loading state definition
export enum LoadingStates {
	IDLE,
	LOADING,
	DEFAULT
}

export const UNAUTHORISED = "Unauthorised";

export const LOGOUT_TIMEOUT = 30 * 60 * 1000;

export const Filters = {
	RESET_BUTTON_LABEL: "Reset to Default"
};

export const ViewMode = {
	READ: "read",
	EDIT: "edit"
};

export const MFA_STATE = {
	enabled: "X",
	disabled: ""
};

export const USER_STATE = {
	enabled: "X",
	disabled: ""
};

export const GROUP_STATE = {
	active: "X",
	inActive: ""
};

export const REIM_VERIFICATION_CONFIG_CODES = {
	START_DATE: "7003",
	END_DATE: "7004",
	DATE_MASTER: "7000"
};

export const ReimbursementClaimStatus = {
	PENDING: "Pending",
	APPROVED: "Approved",
	REJECTED: "Rejected",
	VERIFICATION_PENDING: "Verification pending"
};

export const REIM_DECLARATION_CONFIG_CODES = {
	START_DATE: "7001",
	END_DATE: "7002",
	DATE_MASTER: "7000",
	PROCESS_POST_DATE: "7005"
};

export const ReimbursementSummaryStatus = {
	PENDING: "PENDING",
	ACCEPTED: "ACCEPTED",
	PENDING_VERIFICATION: "PENDING_VERIFICATION",
	PENDING_APPROVAL: "PENDING_APPROVAL",
	APPROVED: "APPROVED",
	FORFEITED: "FORFEITED",
	PROCESSED: "PROCESSED",
	POSTED: "POSTED"
};

export const PageTitles = {
	LOGIN: "Login - Atlas",
	HOME: "Home - Atlas",
	NEW_GROUP: "New Group - Atlas",
	EDIT_GROUP: "View/Edit Group - Atlas",
	NEW_USER: "New User - Atlas",
	EDIT_USER: "View/Edit User - Atlas",
	ROLE_MANAGEMENT: "Role Management - Atlas",
	MONTHLY_DECLARATIONS: "Monthly Declarations - Atlas",
	RETROSPECTIVE_CLAIM: "Retrospective Claim - Atlas",
	OFFER_ISSUANCE: "Offer Issuance - Atlas",
	OFFER_ISSUANCE_APPROVE: "Offer Issuance Approval - Atlas",
	CREATE_RETROSPECTIVE_CLAIM: "Create Retrospective Claim - Atlas",
	APPROVE_RETROSPECTIVE_CLAIM: "Approve Retrospective Claim - Atlas",
	REVIEW_RETROSPECTIVE_CLAIM: "Review Retrospective Claim - Atlas",
	OFFER_REDEMPTION: "Offer Redemption - Atlas",
	OFFER_UPDATE: "Offers Update - Atlas",
	REPORT_GENERATION: "Report Generation - Atlas",
	ADHOC_REPORT_GENERATION: "AD-HOC Report Generation - Atlas",
	MERGE_CR_ACCOUNTS: "Merge CR Accounts - Atlas",
	VOID_CR_TRANSACTION: "Void CR Transaction - Atlas",
	CR_POINTS_EXPIRY_SUMMARY: "CR Points Expiry Summary - Atlas",
	CR_MEMBERSHIP_STATUS: "CR Membership Status - Atlas",
	REJECT_CLAIM: "Reject Claim - Atlas",
	EDIT_REIMBURSEMENT: "Edit Reimbursement - Atlas",
	REJECT_REIMBURSEMENT: "Reject Reimbursement - Atlas",
	FIRST_TIME_LOGIN: "First Time Login - Atlas",
	ACCOUNT_MANAGEMENT: "Account Management - Atlas",
	CREATE_ACCOUNT: "Create Account - Atlas",
	EDIT_ACCOUNT: "Edit Account -Atlas",
	REIMBURSEMENT_CLAIM: "Reimbursement Claim Verification - Atlas",
	REIMBURSEMENT_VERIFICATION_REVIEW: "Reimbursement Review Claim - Atlas",
	REIMBURSEMENT_VERIFICATION_REJECT: "Reimbursement Reject Claim - Atlas",
	CAPITASTAR_DELINK: "CapitaStar Delink - Atlas",
	KRISFLYER_DELINK: "Krisflyer Delink - Atlas",
	VEHICLE_DELINK: "Vehicle IU Delink - Atlas",
	FORGOT_WATCHWORD: "Forgot Password - Atlas",
	PROMO_CODES: "Promo Codes - Atlas",
	OUTLET_MANAGEMENT: "Outlet Management - Atlas",
	CREATE_OUTLET: "Create Outlet - Atlas",
	EDIT_OUTLET: "Edit/ View Outlet - Atlas"
};

export const FirstTimeLogin = {
	DISCLAIMER_TEXT: "To safeguard your account, you are required to change your password now.",
	SUBMIT_BTN_TEXT: "Change Password",
	VERIFICATION_CODE: "Verification Code",
	WATCHWORD_PLACEHOLDER: "New Password",
	CB_LABEL1: "Minimum 10 characters alphanumeric",
	CB_LABEL2: "At least 1 uppercase",
	CB_LABEL3: "At least 1 lowercase",
	CB_LABEL4: "At least 1 special character",
	CONFIRM_WATCHWORD_PLACEHOLDER: "Confirm New Password",
	INVALID_WATCHWORD: "Password should match below requirements.",
	ERR_WATCHWORD: "Please input your password!",
	ERR_CONFIRM_WATCHWORD: "Please confirm your password!",
	ERR_WATCHWORD_MATCH: "The two passwords that you entered do not match!",
	ERR_VERIFICATION_CODE: "You have entered an invalid verification code"
};

export const LoginPage = {
	AUDIT_ACTION_TYPE_CODE: "11013",
	AUDIT_ACTION: "User Login Page",
	FORCE_UPDATE_WATCHWORD_EXPIRY_DAYS: 90,
	FORCE_UPDATE_WATCHWORD_EXPIRY_DAYS_FOR_TENANTS: 180,
	TOTP_LABEL: "Enter TOTP",
	FIELD_TOTP: "totpstring",
	VERIFY_BUTTON: "Verify",
	INVALID_SESSION_TIMEOUT: "Invalid session for the user, session is expired.",
	INVALID_CODE_ERR: "Invalid code received for user",
	SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
	MY_TOTP_DEVICE: "My TOTP device",
	INVALID_OTP: "Invalid TOTP. Please enter correct TOTP",
	SESSION_TIMEOUT_ERR: "Session timeout. Please try login again.",
	TOTP_REQUIRED: "Please enter valid TOTP",
	FIELD_USERNAME: "username",
	ERR_USERNAME_REQUIRED: "Please input Admin ID/Tenant Code",
	SUB_HEADER: "Welcome to Changi Rewards Tenant Portal",
	USERNAME_HINT: "Admin ID/Tenant Code",
	WATCHWORD_HINT: "Password",
	LOGIN_BTN_TEXT: "LOGIN",
	BACK_TO_LOGIN: "Back to Login",
	CREDENTIAL_ERR_RESPONSE: "Incorrect username or password.",
	ATTEMPTS_ERR_RESPONSE: "Password attempts exceeded",
	FORGOT_WATCHWORD_TEXT: "Forgot password?",
	CREDENTIAL_ERR: "The username/password you entered is incorrect. Please try again.",
	ATTEMPTS_ERR: "Your account has been locked because you have exceeded the number of tries. You can reset your password by contacting admin here.",
	LOGIN_ERR: "Something went wrong, please try again.",
	USER_DISABLED_ERR_RESPONSE: "User is disabled.",
	USER_DISABLED_ERR: "This account has been deactivated. Please contact your administrator."
};

export const SuccessMessages = {
	LOGGED_IN: "Successfully logged in!",
	GOT_IT_BTN_TEXT: "Got it!",
	UNSUCCESSFUL_ATTEMPT_COUNT: "Number of unsuccessful attempts: 1",
	LAST_SUCCESSFUL_LOGIN: "Last successful login date/time: "
};

export const NewUser = {
	DISABLE_CHECKBOX: "disable",
	DISABLE_MFA_WARNING_MESSAGE: "Once you opt out from MFA you won't be able to change this preference in future.",
	FIELD_FNAME: "firstname",
	FIELD_LNAME: "lastname",
	FIELD_USERNAME: "username",
	FIELD_EMAIL: "email",
	INVALID_FIRSTNAME: "Invalid first name",
	INVALID_LASTNAME: "Invalid last name",
	INVALID_USERNAME: "Invalid username",
	INVALID_EMAIL: "Invalid email address",
	INDICATOR_MESSAGE: "No actions required for now",
	NEW_USER_HEADER: "New User",
	NEW_USER_SUBHEADER: "Create new user here",
	STEP_1_TEXT: "Step 1",
	STEP_1_SUBHEADER: "Fill in the admin’s username, first name, last name and email address",
	STEP_2_TEXT: "Step 2",
	STEP_2_SUBHEADER: "Add admin to one or more predefined group",
	FIRST_NAME_LABEL: "First Name",
	FIRST_NAME_PLACEHOLDER: "e.g Fabian",
	LAST_NAME_LABEL: "Last Name",
	LAST_NAME_PLACEHOLDER: "e.g Ng",
	USERNAME_LABEL: "Username",
	USERNAME_PLACEHOLDER: "e.g Fabian.Ng",
	EMAIL_LABEL: "Email Address",
	EMAIL_PLACEHOLDER: "e.g fabian.ng@changiairport.com",
	ENABLE_2FA_LABEL: "Enable 2FA",
	ADD_ANOTHER_GROUP_LABEL: "Add another group",
	CREATE_USER_TEXT: "Create User",
	USER_CREATED: "Admin successfully created!",
	USER_CREATED_SUBTITLE: "A system generated password has been emailed to the admin. Please note that they are required to change their password upon first login",
	USER_CREATED_OK_BTN: "Got it!",
	PAGE_TITLE: "View/Edit User",
	PAGE_SUBTITLE: "View or edit user’s administrative rights",
	DEACTIVATE_BUTTON_LABEL: "Deactivate account",
	LOCK_ACCOUNT_LABEL: "Lock account",
	EDIT_ACCOUNT_LABEL: "Edit user account",
	NEW_USER_SUCCESS_MEESSAGE: "User created successfully",
	NEW_USER_ALREADY_EXISTS: "Email address/Username already exists, please try again",
	USER_ALREADY_EXISTS: "User account already exists",
	USERNAME_ALREADY_EXISTS: "User with similar username value already exists",
	EMAIL_ALREADY_EXISTS: "User with similar email address value already exists",
	MULTIPLE_APPROVAL_WARNING: "User should have only one approval limit for retrospective and reimbursement.",
	TENANT_GROUP: "TENANT"
};

export const StatusInfo = {
	NO_ACTION_REQ: "No actions required for now"
};

export const NewGroup = {
	REIMB_DECLRATION_VERIFICATION: "REIMB_DECLRATION_VERIFY",
	DECLARE_VERIFY_MESSAGE: "Please select Reimbursement Voucher Group Access for declaration verifier",
	REIMBURSEMENT_VOUCHER_GROUPS: ["REIMB_VOUCHGRP_NON_MEMBER", "REIMB_VOUCHGRP_NON_CASH", "REIMB_VOUCHGRP_CTPCR_KOR_EV", "REIMB_VOUCHGRP_CR_EV_FLEXI"],
	DECLARATION_VERIFICATION_PERM_GROUP_CODE: "5009",
	NEW_GROUP_HEADER: "New Group",
	NEW_GROUP_SUBHEADER: "Create new group here",
	STEP_1_TEXT: "Step 1",
	STEP_1_SUBHEADER: "Fill in the group’s name",
	STEP_2_TEXT: "Step 2",
	STEP_2_SUBHEADER: "Select the admin rights for this group",
	GROUP_NAME_LABEL: "Group Name",
	GROUP_NAME_PLACEHOLDER: "e.g CSO Joinees",
	GROUP_DESCRIPTION_LABEL: "Group Description",
	GROUP_DESC_PLACEHOLDER: "e.g For new employees",
	CREATE_GROUP_TEXT: "Create Group",
	GROUP_CREATED: "Group successfully created!",
	GROUP_CREATED_MESSAGE: "Group Created successfully",
	DUPLICATE_GROUP: "Group name already exists, please enter a different group name",
	INVALID_GROUP_NAME: "Invalid group name",
	INVALID_GROUP_DESC: "Invalid group description",
	FIELD_NAME: "name",
	FIELD_DESCRIPTION: "description",
	RETRO_CLAIM_PERM_GROUP: "5004",
	REIMB_EV_APPROVAL_PERM_GROUP: "5005",
	REIMB_APPROVAL_PERM_GROUP: "5006",
	REIMB_NON_CASH_APP_LIMIT: "5007",
	REIMB_NON_MEMBER_EV_APP_LIMIT: "5008"
};

export const EditGroup = {
	TITLE: "View/Edit Group",
	SUB_TITLE: "Edit your group here",
	DEACTIVATE_GROUP_LABEL: "Deactivate Group",
	REACTIVATE_GROUP_LABEL: "Reactivate Group",
	EDIT_GROUP: "Edit group",
	GO_BACK: "Go Back",
	MAKE_CHANGES: "Make Changes",
	SUCCESS_MESSAGE: "Changes successfully made!",
	WARNING_MESSAGE: "Proceed to deactivate group?",
	DEACTIVATE_LABEL: "Deactivate",
	DEACTIVATE_SUCCESS_MESSAGE: "Group successfully deactivated!",
	ACTIVATE_SUCCESS_MESSAGE: "Group successfully reactivated!",
	DEACTIVATE_RESP_MESSAGE: "Group deactivated successfully",
	ACTIVATE_RESP_MESSAGE: "Group activated successfully",
	EDIT_RESP_MESSAGE: "Group is updated successfully"
};

export const COGNITO_POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID ?? "";
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID ?? "";
export const USER_INFO_COOKIE = "USER_INFO_COOKIE";

export const Routes = {
	// auth management
	LOGIN: "/login",
	FIRST_TIME_LOGIN: "/new-password",
	FORGOT_WATCHWORD: "/forgot-password",
	LOGOUT: "/logout",
	HOME: "/",

	// role management
	ROLE_MANAGEMENT: "/role-management",
	CREATE_USER: "create-user",
	CREATE_GROUP: "create-group",
	EDIT_GROUP: "edit-group",
	VIEW_EDIT_ADMIN_USER: "edit-user",

	ACCOUNT_MANAGEMENT: "/account-management",
	CREATE_ACCOUNT: "create-account",
	EDIT_ACCOUNT: "edit-account",
	SUCCESS: "/success",
	DECLARATION_APPROVAL: "/declaration-approval",
	RECEIPT_MANAGEMENT: "/receipt-management",
	REPORTS_ADMIN: "/reports-admin",
	NONMEMBER_ACCOUNT: "/nonmember-account",

	// retrospective claim management
	RETRO_CLAIM: "/retro-claim",
	CREATE_RETRO_CLAIM: "create-claim",
	APPROVE_RETRO_CLAIM: "approve-claim",
	REJECT_RETRO_CLAIM: "reject-claim",
	SPECIAL_APPROVE_CLAIM: "special-approve",
	REVIEW_RETRO_CLAIM: "review-claim",

	// offer issuance
	OFFER_ISSUANCE: "/offer-issuance",
	OFFER_REDEMPTION: "/offer-redemption",
	OFFER_ISSUANCE_APPROVE: "/offer-issuance-approve",
	OFFER_ISSUANCE_CREATE: "/offer-issuance",
	OFFER_UPDATE: "/offer-update",

	DELINK: "/capitastar-delink",
	KRISFLYER_DELINK: "/krisflyer-delink",
	VEHICLE_DELINK: "/vehicle-delink",
	SESSIONM: "/sessionM",

	OUTLET_MANAGEMENT: "/outlet-management",
	EV_ENQUIRY_MANAGEMENT: "/v2/ev-enquiry",
	SYSTEM_SETTINGS: "/v2/settings",

	CREATE_OUTLET: "create-outlet",
	EDIT_OUTLET: "edit-outlet/:outletId",

	// Monthly Declarations and Reimbursement
	MONTHLY_DECLARATIONS: "/monthly-declarations",
	MONTHLY_DECLARATIONS_EDIT: "edit-reimbursement",
	MONTHLY_DECLARATIONS_REJECT: "reject-reimbursement",

	// Reports
	REPORTS_TENANT: "/reports-tenant",
	REPORT_GENERATION: "/report-generation",
	REPORT_ADHOC: "/reports-adhoc",

	// Merge CR Accounts
	MERGE_CR_ACCOUNTS: "/merge-cr-accounts",
	CR_POINTS_EXPIRY_SUMMARY: "/points-expiry-summary",
	CR_MEMBERSHIP_STATUS: "/update-membership-status",

	// CR Transactions
	GET_CR_TRANSACTION: "/get-cr-transaction",
	VOID_CR_TRANSACTION: "/void-cr-transaction",

	// reimbursement claim verification
	DECLARATION_VERIFICATION: "/declaration-verification",
	REIMBURSEMENT_CLAIM_REVIEW: "reimbursement-review-claim",
	REIMBURSEMENT_REJECT_CLAIM: "reimbursement-reject-claim"
};

export const RoleManagement = {
	NO_DATA_FOUND: "No data found",
	REPORT_GENERATED: "Users list successfully exported!",
	DEFAULT_EXPANDED_ROW_KEY: "All users",
	DEACTIVATED: "(Deactivated)",
	ROLE_HEADER: "Role Management",
	ROLE_SUB_HEADER: "Overview of admins and groups",
	CREATE_USER_LABEL: "Create User",
	CREATE_GROUP_LABEL: "Create Group",
	SEARCH_BY: "Search by Username, First/Last name, Email address or User Group",
	USERNAME_PLACEHOLDER: "Username/First/Last name/Email address",
	USERGROUP_PLACEHOLDER: "User Group",
	EXPORT_USER_LIST_LABEL: "Export User List",
	FILTER_LABEL: "Filter",
	VIEW_EDIT_GROUP_LABEL: "View/Edit Group",
	FIRST_ACCORDION_TAB: "0",
	USER_GROUP_LIST: {
		ALL_USER_GROUP: "All Users",
		ALL_USER_GROUP_CODE: "ALL user group",
		ACTIVE: "X",
		GROUP_ID: 0,
		STATUS: ["Active", "Deactivated"]
	},

	DEFAULT_ROW_PER_PAGE: 5,
	ROW_PER_PAGE_10: 10,
	DEFAULT_STATUS: [
		{
			name: "Status / Date & Time created",
			value: "Sort by status (Active first)",
			checked: true
		},
		{
			name: "Records per page",
			value: "Display 5 records per page",
			checked: true
		}
	],
	ALL_USERS_GROUP: {
		group_id: 0,
		group_code: "All users",
		group_desc: "All Users",
		active: "X"
	},
	USER_GROUP_NOT_FOUND: "User Group not found",
	CREATE_EDIT_ADMIN_ACCOUNT: "CREATE_EDIT_ADMIN_ACCOUNT",
	CREATE_EDIT_GROUP: "CREATE_EDIT_GROUP"
};

export const AccountManagement = {
	ROLE_HEADER: "Account Management",
	ROLE_SUB_HEADER: "Overview of tenant accounts",
	CREATE_ACCOUNT_LABEL: "Create Account",
	SEARCH_BY: "Search by Tenant name, Username, Email address or Tenant Code",
	USERNAME_PLACEHOLDER: "Tenant name/Username/Email address",
	TENANT_CODE_PLACEHOLDER: "Tenant Code",
	FILTER_LABEL: "Filter",
	USER_GROUP_LIST: {
		ALL_USER_GROUP: "All Users",
		ALL_USER_GROUP_CODE: "ALL user group",
		ACTIVE: "X",
		GROUP_ID: 0,
		STATUS: ["Active", "Deactivated"]
	},

	DEFAULT_ROW_PER_PAGE: 5,
	ROW_PER_PAGE_10: 10,
	DEFAULT_STATUS: [
		{
			name: "Status / Date & Time created / Last login Date & Time",
			value: "Sort by status (Active first)",
			checked: true
		},
		{
			name: "Records per page",
			value: "Display 5 records per page",
			checked: true
		}
	],
	TENANT: {
		active: "X",
		group_code: "TENANT",
		group_desc: "Tenant",
		group_id: 1
	},
	CREATE_ACCOUNT: {
		CREATE_ACCOUNT_HEADER: "New Tenant account",
		CREATE_ACCOUNT_SUB_HEADER: "Create new admin here",
		TENANT_NAME_LABEL: "Tenant name or code",
		FIELD_TENENT: "tenent_name",
		SEARCH_LABEL: "e.g Uniqlo or 10003515",
		FILL_LABEL: "Fill in the username and email address",
		INVALID_USERNAME: "Invalid username",
		USERNAME_LABEL: "Username",
		USERNAME_INPUT_PLACEHOLDER: "e.g Fabia.Ng",
		INVALID_EMAIL: "Invalid email",
		EMAIL_LABEL: "Email Address",
		EMAIL_INPUT_PLACEHOLDER: "e.g fabian.ng@changiairport.com",
		BUTTON_LABEL: "Create Account",
		CANNOT_SEND_REQUEST: "Cannot send request",
		NO_ACTIVE_TENANT: "There is no active TENANT group in system",
		TENANT_SUCCESS_CREATED: "Tenant account successfully created!",
		GOT_IT: "Got it!",
		TENANT_SUCCESS_SUBTITLE: "A system generated password has been emailed to the admin. Please note that they are required to change their password upon first login"
	},
	EDIT_ACCOUNT: {
		EDIT_ACCOUNT_HEADER: "View/Edit Tenant",
		EDIT_ACCOUNT_SUBHEADER: "View or edit user’s administrative rights",
		GO_BACK: "Go Back",
		EDIT_USER_LABEL: "Edit User Account",
		UNLOCK_ACCOUNT: "Unlock Account",
		MAKE_CHANGES: "Make Changes",
		LOCK_ACCOUNT: "Lock account",
		ACTIVATE_ACCOUNT: "Activate account",
		DEACTIVATE_ACCOUNT: "Deactivate account",
		ACCOUNT_DEACTIVATED_SUCCESS: "Account successfully deactivated!",
		SOMETHING_WENT_WRONG_MESSAGE: "Something went wrong. Please try again",
		PROCEED_TO_DEACTIVATE: "Proceed to deactivate account?",
		DEACTIVATE_LABEL: "Deactivate",
		ACCOUNT_REACTIVATED_SUCCESS: "Account successfully reactivated!",
		ACCOUNT_SUCCESSFULLY_LOCKED: "Account successfully locked!",
		ACCOUNT_SUCCESSFULLY_UNLOCKED: "Account successfully unlocked!",
		PROCEED_TO_LOCK: "Proceed to lock account?",
		LOCK_ACCOUNT_LABEL: "Lock Account",
		CHANGES_SUCCESSFULLY_MADE: "Changes successfully made!",
		RESEND_PASSWORD_BUTTON_LABEL: "Resend Temporary Password",
		RESEND_PASSWORD_BTN_LABEL: "Resend",
		ACCOUNT_RESEND_PASSWORD_SUCCESS: "Temporary password resent successfully!",
		ACCOUNT_RESEND_PASSWORD_WARNING: "Proceed to resend temporary password?",
		ACCOUNT_RESEND_PASSWORD_SUCCESS_RESPONSE: "Temporary password resent successfully"
	}
};
export const Columns = [
	{
		title: "Date & Time Created",
		dataIndex: "dateandTime",
		key: "key"
	},
	{
		title: "Last login Date & Time",
		dataIndex: "lastloginDateTime",
		key: "key"
	},
	{
		title: "Group",
		dataIndex: "Group",
		key: "key"
	},
	{
		title: "Retro Claim limit",
		dataIndex: "retroClaimLimit",
		key: "key"
	},
	{
		title: "2FA Enabled",
		dataIndex: "twoFAEnabled",
		key: "key"
	},
	{
		title: "Username",
		dataIndex: "Username",
		key: "key"
	},
	{
		title: "First Name",
		dataIndex: "Firstname",
		key: "key"
	},
	{
		title: "Last Name",
		dataIndex: "Lastname",
		key: "key"
	},
	{
		title: "Email Address",
		dataIndex: "emailAddress",
		key: "key"
	}
];

export const ViewEditUser = {
	PAGE_TITLE: "View/Edit User",
	PAGE_SUBTITLE: "View or edit user’s administrative rights",
	DEACTIVATE_BUTTON_LABEL: "Deactivate account",
	LOCK_ACCOUNT_LABEL: "Lock account",
	EDIT_ACCOUNT_LABEL: "Edit user account",
	MAKE_CHANGES: "Make Changes",
	GO_BACK_LABEL: "Go back",
	GOT_IT_BTN_TEXT: "Got it!",
	CREATE_USER_BTN_TEXT: "Create new User",
	DEACTIVATE_BTN_LABEL: "Deactivate",
	LOCK_BTN_LABEL: "Lock account",
	TOOLTIP_TITLE: "You are not allowed to change the 2FA settings",
	TOOLTIP_SUBTITLE: "Please delete this user and create a new one if you require 2FA to be enabled/disabled",
	ACC_DEACTIVATE_SUCCESS: "Account successfully deactivated!",
	ACC_DEACTIVATE_WARNING: "Proceed to deactivate account?",
	ACC_LOCK_SUCCESS: "Account successfully locked!",
	ACC_LOCK_WARNING: "Proceed to lock account?",
	ACC_EDIT_SUCCESS: "Changes successfully made!",
	REACTIVATE_USER_LABEL: "Reactivate account",
	ACC_ACTIVATE_SUCCESS: "Account successfully activated!",
	ACC_ACTIVATE_SUCCESS_RESPONSE: "Account activated successfully",
	ACC_DEACTIVATE_SUCCESS_RESPONSE: "Account deactivated successfully",
	ACC_EDIT_SUCCESS_RESP: "User updated sucessfully",
	RESEND_PASSWORD_BUTTON_LABEL: "Resend Temporary Password",
	RESEND_PASSWORD_BTN_LABEL: "Resend",
	ACC_RESEND_PASSWORD_SUCCESS: "Temporary password resent successfully!",
	ACC_RESEND_PASSWORD_WARNING: "Proceed to resend temporary password?",
	ACC_RESEND_PASSWORD_SUCCESS_RESPONSE: "Temporary password resent successfully",
	ERROR_MESSAGE: "Something went wrong. Please try again",
	MULTIPLE_APPROVAL_WARNING: "User should have only one approval limit for retrospective and reimbursement."
};

export const RETRO_CLAIM = {
	REJECTED_STATUS: "REJECTED",
	APPROVED_STATUS: "APPROVED",
	PAGE_TITLE: "Retrospective Claim",
	PAGE_SUBTITLE: "Create or review retrospective claims here",
	BUTTON_LABELS: {
		CREATE_CLAIM: { label: "Create Claim" }
	},
	DEFAULT_GROUP_CODE: {
		perm_group_code: "5004"
	},
	DEFAULT_ROW_PER_PAGE: 10,
	CLAIMS_PENDING_ACTION_GROUP: {
		perm_id: 0,
		perm_code: "CLAIMS_PENDING_ACTION",
		perm_short_desc: "Claims pending your action",
		perm_long_desc: "Claims pending your action",
		perm_group_code: "0",
		perm_group_desc: "",
		perm_val1: 0.0,
		perm_val2: 0.0
	},
	PERMISSION_CODE: "5004",
	DEFAULT_STATUS: [
		{
			name: "Filter by",
			value: "Status (Pending first)",
			checked: true
		},
		{
			name: "Sort by",
			value: "Receipt Date & Time  (Newest to Oldest)",
			checked: true
		}
	],
	PAGE_STATUS: {
		APPROVE: "approve",
		REJECT: "reject",
		SPL_APPROVE: "splApprove"
	},
	PENDING_GROUP_NAME: "CLAIMS_PENDING_ACTION",
	PENDING_STATUS_ARRAY: ["PENDING", "PENDING_APPROVAL"]
};
export const REIMBURSMENT_DECL_VERIFICATION = {
	CONFIG_MASTER_CODE_VOUCHER_TYPES: "6000",
	DECL_VERIFICATION_PAGE_TITLE: "Claims verification",
	DECL_APPROVAL_PAGE_TITLE: "Claims approval",
	PAGE_SUBTITLE: "Approve or reject reimbursement claims by tenants",
	DEFAULT_DECLARATION_VERIFICATION_STATUS: "PENDING_VERIFICATION",
	DEFAULT_ROW_PER_PAGE: 10,
	VERIFIER_APPROVED_STATUS: "Approved",
	VERIFIER_REJECTED_STATUS: "Rejected",
	DEFAULT_STATUS: [
		{
			name: "Date & Time / Tenant / Outlet",
			value: "Date & Time  (Newest to Oldest)",
			checked: true
		}
	],
	CLAIM_STATUS: {
		["/declaration-verification"]: "PENDING_VERIFICATION",
		["/declaration-approval"]: "PENDING_APPROVAL"
	},
	APPROVAL_STATUS: "approval",
	VERIFICATION_STATUS: "verification",
	REIMB_VOUCHER_GROUP_ACCESS: "5009"
};

export const CREATE_RETRO_CLAIM = {
	PAGE_TITLE: "Create claim",
	PAGE_SUBTITLE: "Create a retrospective claim here",
	BUTTON_LABELS: {
		CREATE_CLAIM: { label: "Create Claim", background: "green" as BackgroundType },
		CANCEL: { label: "Cancel", background: "red" as BackgroundType }
	},
	SPECIAL_APPROVAL_TEXT: "Or seek special approval here",
	MESSAGE: "*Only png, jpg and jpeg files are supported"
};

export const REVIEW_RETRO_CLAIM = {
	PAGE_TITLE: "Review claim",
	PAGE_SUBTITLE: "Review a retrospective claim here",
	BUTTON_LABELS: {
		APPROVE: { label: "Approve", background: "green" as BackgroundType },
		REJECT: { label: "Reject", background: "red" as BackgroundType },
		UPDATE_CLAIM: { label: "Update Claim", background: "violet" as BackgroundType },
		CANCEL: { label: "Cancel", background: "red" as BackgroundType }
	},
	SPECIAL_APPROVAL_TEXT: "Or seek special approval here",
	REVIEW_MODAL_TITLE: "Unable to approve due to the following reason(s)",
	CANNOT_SEND_REQUEST: "Cannot send request",
	MESSAGE_AGENT: "Message history with Agent",
	MESSAGE_APPROVER: "Message history with Approver",
	COLUMN_HEADERS: {
		REVIEW_DATETIME: {
			dataIndex: "review_dt",
			title: "Reviewed Date & Time"
		},
		MESSAGE: {
			dataIndex: "message",
			title: "Message"
		},
		AGENT_ID: {
			dataIndex: "agent_id",
			title: "Agent ID"
		},
		ATTACHMENTS: {
			dataIndex: "attachments",
			title: "Attachments"
		}
	},
	REJECTED_STATUS: "REJECTED"
};

export const SPECIAL_APPROVAL_RETRO_CLAIM = {
	INVALID_REJECTION_ERR: "Please enter valid reason. (Allowed alphabets, number, space and . , - + = $)",
	PAGE_TITLE: "Approval request",
	PAGE_SUBTITLE: "For retrospective claims that requires case-by-case approval",
	BUTTON_LABEL: "Send approval request",
	STATUS_LABEL: "Status",
	SOURCE_LABEL: "Source",
	REASON_FOR_APPROVAL: "Reason for special approval",
	SUCCESS_MESSAGE: "Approval request sent!",
	/**
	 * @info .vnd.ms-excel added as accepted file type based on MIME type xls
	 * @info .vnd.ms-outlook and .vnd.openxmlformats-officedocument.spreadsheetml.sheet are added as accepted file type based on MIME type for msg and xlsx
	 */
	SPECIAL_APPROVAL_FILETYPE: ".xls, .xlsx, .csv, .pdf, .png, .jpg, .jpeg, .vnd.ms-excel, .msg, .vnd.ms-outlook, .vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	MESSAGE: "*Only xls, csv, pdf, png, jpg and jpeg files not exceeding 5MB is supported",
	CANNOT_SEND_REQ: "Cannot send request",
	API_ERROR: "! If issue persists, consider reducing the overall file size of the supporting documents"
};

export const APPROVE_RETRO_CLAIM = {
	PAGE_TITLE: "Approve claim",
	PAGE_SUBTITLE: "Review retrospective claim before approving",
	FIELD_RECEIPT_DATETIME: "receipt_date_time",
	FIELD_OUTLET: "outlet",
	FIELD_PURCHASE_AMOUNT: "purchase_amount",
	FIELD_NETT_AMOUNT: "nett_amount",
	CONFIRM_BUTTON: "Confirm",
	GOBACK_BUTTON: "Go Back",
	RECEIPT_DATETIME: "Receipt Date & Time",
	OUTLET: "Outlet",
	PURCHASE_AMOUNT: "Purchase Amount",
	NETT_AMOUNT: "Nett Amount",
	RECEIPT_DATE_ERROR: "Receipt Date is older than 365 days",
	NETT_AMOUNT_ERROR: "Nett amount is less than S$10"
};

export const CREATE_RETRO_CLAIM_FORM = {
	USERNAME: "Username",
	USERNAME_PLACEHOLDER: "Enter name",
	AGENT_ID: "Agent ID",
	AGENT_ID_PLACEHOLDER: "e.g 463816284",
	RECEIPT_NUMBER: "Receipt Number",
	RECEIPT_NUMBER_PLACEHOLDER: "e.g A220000038664",
	OUTLET: "Outlet",
	TERMINAL: "Terminal",
	OUTLET_PLACEHOLDER: "e.g Shilla",
	TERMINAL_PLACEHOLDER: "e.g T1",
	CARD_NUMBER: "Card Number",
	CARD_NUMBER_PLACEHOLDER: "e.g 000020010003120177",
	RECEIPT_DATE_TIME: "Receipt Date & Time",
	RECEIPT_DATE_TIME_PLACEHOLDER: "Receipt Date & Time Placeholder",
	PURCHASE_AMOUNT: "Purchase Amount",
	PURCHASE_AMOUNT_PLACEHOLDER: "e.g S$1000.00",
	NET_AMOUNT: "Nett Amount",
	NET_AMOUNT_PLACEHOLDER: "e.g S$1000.00",
	SOURCE_LABEL: "Source",
	SOURCE_SELECT_LABEL: "Select source",
	SOURCE_OPTION_1: "Webform",
	ERROR_MESSAGE: {
		RECEIPT_NUMBER: "Wrong Receipt number",
		CARD_NUMBER: "Wrong Card number",
		RECEIPT_DATE_TIME: "Enter valid receipt date",
		PURCHASE_AMOUNT: "Enter valid purchase amount",
		NET_AMOUNT: "Enter valid net amount",
		IMAGE_MORE_SIZE: "Image must smaller than 3MB!",
		FILE_TYPE_ERROR: "Uploaded file type is not supported!"
	},
	AMOUNT_INPUT_PREFIX: "S$"
};

export const CreditPointsTooltip = {
	DESC_PART1: "The maximum amount of points a member can earn is based on ",
	DESC_PART2: "$5000 nett spend per transaction.",
	MISC_DATA: [
		{ title: "Member tier: ", desc: "Max 5000 CR points" },
		{ title: "Gold/Staff Gold tier: ", desc: "Max 10000 CR points" },
		{ title: "Platinum/Staff Platinum tier: ", desc: "Max 30000 CR points" }
	]
};

export const RejectRetroClaim = {
	INVALID_REJECTION_ERR: "Please enter valid reason. (Allowed alphabets, number, space and . , - + = $)",
	REJECT_CLAIM_HEADER: "Reject Claim",
	REVIEW_RETRO_CLAIM_SUBHEADER: "Review retrospective claim before rejecting",
	REASON_LABEL: "Reason for rejection",
	FIELD_REASON_LABEL: "rejection_reason",
	GOBACK_BUTTON: "Go Back",
	REJECT_BUTTON: "Reject",
	CLAIM_REJECTED: "This claim has been rejected",
	CLAIM_REJECTED_SUBTITLE: "CR members will be notified of the rejection",
	CLAIM_SUCCESS_MESSAGE: "Claim successfully rejected.",
	CLAIM_ERROR_MESSAGE: "Claim rejection unsuccessfull"
};

export const ReportGeneration = {
	DATE_PLACEHOLDER: "Choose a date",
	CANNOT_GENERATE_REPORT: "Cannot generate report for future dates",
	CONFIG_MASTER_CODE_VOUCHER_TYPES: "6000",
	REPORT_GENERATION_START_YEAR: 2022,
	REPORT_GENERATION_TENANT_WITH_MULTIPLE_OUTLETS: {
		STEP_1_TEXT: "Step 1",
		STEP_1_SUBHEADER: "Search with Outlet name/code or select all outlet",
		STEP_2_TEXT: "Step 2",
		STEP_2_SUBHEADER: "Select Report type",
		STEP_3_TEXT: "Step 3",
		STEP_3_SUBHEADER: "Select Voucher type",
		STEP_4_TEXT: "Step 4",
		STEP_4_SUBHEADER_SETTLEMENT: "Choose a month and year",
		STEP_4_SUBHEADER_REDEMPTION: "Choose a date",
		STEP_5_TEXT: "Step 5 (Optional)",
		STEP_5_SUBHEADER_SETTLEMENT: "You can create reports for a specific period of time by selecting an end month and year",
		STEP_5_SUBHEADER_REDEMPTION: "You can create reports for a specific period of time by selecting an end date",
		TENENT_NAME_CODE: "Tenant Name/Code e.g Uniqlo 10003515",
		SELECT_ALL: "Select all outlets"
	},
	REPORT_GENERATION_ADMIN: {
		STEP_1_TEXT: "Step 1",
		STEP_1_SUBHEADER: "Select report type",
		STEP_2_TEXT: "Step 2",
		STEP_2_SUBHEADER: "Select voucher type",
		STEP_3_TEXT: "Step 3",
		STEP_3_SUBHEADER: "Select Airport Teminal",
		STEP_4_TEXT: "Step 4 ",
		STEP_4_SUBHEADER: "Search with Tenant or Outlet name/code",
		STEP_5_TEXT: "Step 5",
		STEP_5_SUBHEADER: "Choose a month and year",
		STEP_6_TEXT: "Step 6 (Optional)",
		STEP_6_SUBHEADER: "You can create reports for a specific period of time by selecting an end month and year",
		TERMINAL_TYPE: [
			{ id: "1", value: "1" },
			{ id: "2", value: "2" },
			{ id: "3", value: "3" }
		],
		TENENT_NAME_EX: "Tenant Name/Code e.g Uniqlo 10003515",
		OUTLET_NAME_EX: "Outlet Name/Code e.g Uniqlo 8000200479001"
	},
	REPORT_TYPE_LABEL: "Report Type",
	VOUCHER_TYPE_LABEL: "Voucher Type",
	TERMINAL: "Terminal",
	SELECT_MONTH: "Select month",
	SELECT_YEAR: "Select year",
	REPORT_TYPE: [
		{
			id: "settlement_report",
			value: "Settlement Report"
		},
		{
			id: "voucher_redemption_report",
			disabled: false,
			value: "Voucher Redemption Report"
		}
	],
	VOUCHER_REDEMPTION_REPORT: "Voucher Redemption Report",
	ADMIN_REPORT_TYPE: [
		{
			id: "rejected_revised_declaration_report",
			value: "Rejected/Revised Declaration Report"
		},
		{
			id: "voucher_reimbursement_report",
			value: "Voucher Reimbursement Report"
		},
		{
			id: "voucher_redemption_report",
			value: "Voucher Redemption Report"
		},
		{
			id: "retrospective_claim_report",
			value: "Retrospective Claims Reports"
		}
	],
	SHOW_DATEPICKERS: ["Voucher Redemption Report", "Retrospective Claims Reports"],
	VOUCHER_TYPE: [
		{ id: "CR_eV_Flexi", value: "CR eV Flexi" },
		{ id: "CR_eV_Airport", value: "CR eV Airport" },
		{ id: "CTP_eV", value: "CTP eV" }
	],
	NEW_USER_HEADER: "Report",
	NEW_USER_SUBHEADER: "Generate report for your Tenant",
	REPORT_GENERATED: "Report is successfully generated!",
	DOWNLOAD_REPORT: "Download Report",
	MONTH: [
		{ id: "January", value: "01", label: "January" },
		{ id: "February", value: "02", label: "February" },
		{ id: "March", value: "03", label: "March" },
		{ id: "April", value: "04", label: "April" },
		{ id: "May", value: "05", label: "May" },
		{ id: "June", value: "06", label: "June" },
		{ id: "July", value: "07", label: "July" },
		{ id: "August", value: "08", label: "August" },
		{ id: "September", value: "09", label: "September" },
		{ id: "October", value: "10", label: "October" },
		{ id: "November", value: "11", label: "November" },
		{ id: "December", value: "12", label: "December" }
	],
	NO_DATA_FOUND: "No data found",
	SETTLEMENT_REPORT_TYPE: "Settlement Report",
	VOUCHER_REPORT_TYPE: "Voucher Reimbursement Report",
	DATE_TYPE: {
		START_DATE: "start_date",
		END_DATE: "end_date"
	},
	DATE_RANGE_ERROR: "Date should not be greater than current date."
};

export const getYearList = () => {
	const currentTime = new Date();
	const year = currentTime.getFullYear();
	const years = [];
	for (let i = ReportGeneration.REPORT_GENERATION_START_YEAR; i <= year; i++) {
		years.push({ id: `${i}`, value: `${i}` });
	}
	return years;
};

export const REVIEW_RETRO_CLAIM_FORM = {
	STATUS_LABEL: "Status",
	SOURCE_LABEL: "Source",
	SUBMISSION_DATETIME: "Submission Date & Time",
	USERNAME: "Username",
	AGENT_ID: "Agent ID",
	RECEIPT_NUMBER: "Receipt Number",
	RECEIPT_NUMBER_PLACEHOLDER: "e.g A220000038664",
	CARD_NUMBER: "Card Number",
	CARD_NUMBER_PLACEHOLDER: "e.g 000020010003120177",
	RECEIPT_DATE_TIME: "Receipt Date & Time",
	RECEIPT_DATE_TIME_PLACEHOLDER: "Receipt Date & Time Placeholder",
	PURCHASE_AMOUNT: "Purchase Amount",
	PURCHASE_AMOUNT_PLACEHOLDER: "e.g S$1000.00",
	NET_AMOUNT: "Nett Amount",
	NET_AMOUNT_PLACEHOLDER: "e.g S$1000.00",
	CLAIM_STATUS_PENDING: "PENDING",
	CLAIM_STATUS_PENDING_APPROVAL: "PENDING_APPROVAL",
	REJECTED_STATUS: "REJECTED",
	APPROVED_STATUS: "APPROVED",
	DATE_FORMAT: "DD MMM, HH:MM",
	PAYLOAD_DATE_FORMAT: "YYYY-MM-DD",
	ERROR_MESSAGE: {
		RECEIPT_NUMBER: "Wrong Receipt number",
		CARD_NUMBER: "Wrong Card number",
		RECEIPT_DATE_TIME: "Enter valid receipt date",
		PURCHASE_AMOUNT: "Enter valid purchase amount",
		NET_AMOUNT: "Enter valid net amount",
		TIER: "Select a valid Tier",
		OUTLET_INACTIVE: "Selected outlet is inactive. Please select a terminal first, then select an active outlet."
	},
	OUTLET: "Outlet",
	TERMINAL: "Terminal",
	TERMINAL_PLACEHOLDER: "e.g. T1",
	OUTLET_PLACEHOLDER: "e.g Shilla",
	NO_DATA_FOUND: "No data found",
	AMOUNT_INPUT_PREFIX: "S$",
	NET_AMOUNT_LIMIT: 10,
	RECEIPT_DATETIME_ERROR: "Receipt date and time is more than 365 days",
	NET_AMOUNT_ERROR: "Net amount should be equal to or greater than 10S$",
	CANNOT_SEND_REQUEST: "Cannot send request"
};

export const EDIT_REJECT_PAGE_TEMPLATE = {
	TEXTAREA_FORM_NAME: "Reason",
	TEXTAREA_PLACEHOLDER: "Type your text here...",
	TEXTAREA_ERROR: "A maximum of 1000 characters with alphabet, numbers, space and , . - = + $ are allowed",
	INPUT_FORM_NAME: "Amount",
	INPUT_PLACEHOLDER: "S$300.00",
	INPUT_ERROR: "Enter Valid amount",
	ERROR_TEXT: "These fields are required",
	SUBMIT_BUTTON_LABEL: "Submit",
	SUBMIT_BUTTON_BG: "green",
	ACCEPT_ORIGINAL_AMOUNT_TEXT: "Or accept original reimbursement amount here",
	GO_BACK: "Go back",
	FROM_EDIT: "edit",
	EDIT_SUBMISSION_LABEL: "Edit Submission",
	SAVE_CHANGES_LABEL: "Save Changes",
	CLAIM_REJECTED_LABEL: "This claim has been rejected",
	CLAIM_REJECTED_SUBLABEL: "Our team will review your claim request and get back to you on the 15th of the month",
	DECLARATION_CHANGED_LABEL: "Declaration successfully changed!",
	CHANGES_MADE_LABEL: "Changes successfully made!",
	PROCEED_ORIGINAL_AMOUNT_LABEL: "Proceed to accept original reimbursement amount?",
	PROCEED_ORIGINAL_AMOUNT_SUBLABEL_1: "You will still be able to edit your submission before the ",
	PROCEED_ORIGINAL_AMOUNT_SUBLABEL_2: "th of the month",
	CANNOT_SEND_REQUEST: "Cannot send request",
	ACCEPT_LABEL: "Accept",
	GOT_IT_LABEL: "Got it!",
	AMOUNT_INPUT_PREFIX: "S$"
};

export const EDIT_MONTHLY_REIMBURSMENT = {
	STEPS_INFO: [
		{ step: 1, subHeader: "Upload your supporting documents*", message: "*Only xls, csv, eml, pdf, png, jpg and jpeg files not exceeding 5MB is supported" },
		{ step: 2, subHeader: "Let us know why you are editing this reimbursement amount" },
		{
			step: 3,
			subHeader: "Indicate the revised amount",
			message: "If CAG’s reimbursement amount is $250 and there’s a discrepancy of $100, the revised amount would be $250 + $100 = $350"
		}
	],
	HEAD_TITLE: PageTitles.EDIT_REIMBURSEMENT,
	STATUS_INFO: { background: "yellow" as Background, message: "statusInfoMessage" },
	PAGE_TITLE: "Edit Submission",
	PAGE_SUBTITLE: "Follow the instructions below to edit the reimbursement claim"
};

export const REJECT_MONTHLY_REIMBURSEMENT = {
	STEPS_INFO: [
		{ step: 1, subHeader: "Upload your supporting documents*", message: "*Only xls, csv, eml, pdf, png, jpg and jpeg files not exceeding 5MB is supported" },
		{ step: 2, subHeader: "Let us know why you are rejecting this reimbursement amount" },
		{
			step: 3,
			subHeader: "Indicate the revised amount",
			message: "If CAG’s reimbursement amount is $250 and there’s a discrepancy of $100, the revised amount would be $250 + $100 = $350"
		}
	],
	HEAD_TITLE: PageTitles.REJECT_REIMBURSEMENT,
	STATUS_INFO: { background: "red" as Background, message: "statusInfoMessage" },
	PAGE_TITLE: "Reject reimbursement",
	PAGE_SUBTITLE: "Please follow the instructions below for us to better assist you"
};

export const FILE_UPLOAD_CONSTANT = {
	UPLOAD_TEXT: "Drag & drop your files here or ",
	BROWSE: "browse",
	NOTE: "A maximum of three files can be selected",
	MAXIMUM_FILE_LIMIT: "Cannot submit as uploaded content exceeded 5MB!",
	/**
	 * @info .rfc822 and .vnd.ms-excel are added as accepted file types based on MIME type for eml and xls
	 * @info .vnd.ms-outlook and ".vnd.openxmlformats-officedocument.spreadsheetml.sheet" are added as accepted file type based on MIME type for msg and xlsx
	 */
	EDIT_MONTHLY_REIMBURSMENT_FILETYPE:
		".xls, .xlsx, .csv, .eml, .pdf, .png, .jpg, .jpeg, .rfc822, .vnd.ms-excel, .msg, .vnd.ms-outlook, .vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	REJECT_MONTHLY_REIMBURSMENT_FILETYPE:
		".xls, .xlsx, .csv, .eml, .pdf, .png, .jpg, .jpeg, .rfc822, .vnd.ms-excel, .msg, .vnd.ms-outlook, .vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	IMAGE_FILETYPE: ".jpg, .jpeg, .png",
	UNSUPPORTED_FILE_TYPE: "Unsupported file type uploaded. Kindly review the upload list",
	FILETYPE_MSG: ".msg",
	FILETYPE_VND_MS_OUTLOOK: "application/vnd.ms-outlook"
};

export const LandingPage = {
	TITLE: "Welcome to the Admin Portal",
	DESC_PREFIX: "To begin, ",
	DESC: "select a module on the left"
};

export const ReimbursementVerificationReview = {
	NO_DATA_FOUND: "No data found",
	ROLE_HEADER: "Review claim",
	ROLE_SUB_HEADER: "Approve or reject reimbursement claims by tenants",

	STATUS_LABEL: "Status",
	VERIFIER_LABEL: "Verifier",
	FIELD_STATUS: "status",

	TENANT_LABEL: "Tenant",
	FIELD_TENANT: "tenant",

	OUTLET_LABEL: "Outlet",
	FIELD_OUTLET: "outlet",

	NET_AMOUNT_LABEL: "Nett Amount",
	FIELD_NET_AMOUNT: "net_amount",

	DECLARED_AMOUNT_LABEL: "Declared Amount",
	FIELD_DECLARED_AMOUNT: "declared_amount",
	REIMBURSEMENT_AMOUNT_LABEL: "Reimbursement Amount",
	FIELD_REIMBURSEMENT_AMOUNT: "reimbursement_amount",
	TENANT_REMARK_LABEL: "Tenant’s remark",
	FIELD_TENANT_REMARK: "tenant_remark",
	VERIFIER_REMARK_LABEL: "Verifier’s reason for rejection",
	FIELD_VERIFIER_REMARK: "verifier_remark",

	APPROVE_BTN_LABEL: "Approve",
	REJECT_BTN_LABEL: "Reject",

	APPROVE_CLAIM_MESSAGE: "This claim has been approved!",
	REJECT_CLAIM_MESSAGE: "This claim has been rejected!",

	CHANGES_MADE_SUCCESSFULLY: "Changes successfully made!",

	FIELD_REJECTION_REASON: "rejection_reason",
	REJECTION_REASON_LABEL: "Rejection reason",

	REJECTION_REASON_PLACEHOLDER: "Rejection reason",

	SAVE_CHANGES_LABEL: "Save Changes",
	REQUIRED_ERR: "This field is required",
	INVALID_REJECTION_ERR: "Please enter valid reason. (Allowed alphabets, number, space and . , - + = $)"
};

export const ReimbursementRejectClaim = {
	ROLE_HEADER: "Reject Claim",
	ROLE_SUB_HEADER: "Reject reimbursement claims by tenants",

	STEP1_HEADER: "Fill in the reimbursement amount below",
	STEP2_HEADER: "Indicate rejection reason here",

	FIELD_REIM_AMOUNT: "reim_amount",
	REIM_AMOUNT_PLACEHOLDER: "e.g $250",

	FIELD_REJECTION_REASON: "rejection_reason",
	REJECTION_REASON_PLACEHOLDER: "e.g Issue with POS",

	REJECT_BTN_LABEL: "Reject",
	REQUIRED_ERR: "This field is required",

	INVALID_AMOUNT_ERR: "Please enter valid amount.",
	INVALID_REJECTION_ERR: "Please enter valid reason. (Allowed alphabets, number, space and . , - + = $)"
};

export const MONTHLY_DECLARATIONS = {
	PAGE_TITLE: "Monthly Declarations",
	PAGE_DESCRIPTION: "Overview of declarations required for different types of vouchers",
	GROUP_DESCRIPTION: "Payment will be credited approximately 2.5 weeks after the 15th of each month",
	ACCORDION_HEADER_DESC: {
		MONTH: "MONTH",
		AMOUNT: "AMOUNT",
		DECLARED: "DECLARED",
		REIMBURSEMENT: "REIMBURSEMENT",
		STATUS: "STATUS",
		DOWNLOAD: "DOWNLOAD"
	},
	DECLARE_VARIANT: "DECLARE",
	VIEW_EDIT_VARIANT: "VIEWEDIT",
	VIEW_VARIANT: "VIEW",
	BUTTON_LABELS: {
		ACCEPT: { label: "Accept", background: "green" as BackgroundType },
		REJECT: { label: "Reject", background: "red" as BackgroundType },
		DECLARE: { label: "Declare", background: "violet" as BackgroundType },
		VIEW: { label: "View", background: "yellow" as BackgroundType },
		VIEWEDIT: { label: "View/Edit", background: "yellow" as BackgroundType }
	},
	DEFAULT_STATUS: [
		{
			name: "Transaction Date & Time / Purchase Value / eVoucher Value / eVoucher Qty & Type",
			value: "Transaction Date & Time (Newest to Oldest)",
			checked: true
		},
		{
			name: "Records per page",
			value: "Display 20 records per page",
			checked: true
		}
	],
	DEFAULT_ROW_PER_PAGE: 20,
	ROW_PER_PAGE_30: 30,
	REQUEST_NOT_SENT: "Cannot send request",
	CONTACT_ADMIN: "Contact your admin here to request for access",
	REPORT_NOT_GENERATED: "Error in generating report",
	REPORT_GENERATED: "Report generated successfully!"
};

export const CapitaStarDelink = {
	OUTLET_CODE: "ADMINPORTAL",
	PAGE_TITLE: "CapitaStar Delink",
	PAGE_SUBTITLE: "Follow the instructions below to delink CapitaStar member ID from CR",
	SEARCH_TITLE: "Enter CR member’s card number or User ID",
	CARD_NUM_PLACEHOLDER: "CR card number e.g 0002001000031201771",
	USER_ID_PLACEHOLDER: "User ID e.g 759273819",
	SEARCH_TEXT: "Search for member ID",
	ACCOUNT_TYPE: "CapitaStar",
	MEMBER_ID_LABEL: "CapitaStar member ID",
	BUTTON_LABEL: "Delink",
	ALREADY_DELINKED: "Member ID is already delinked!",
	ERROR_MESSAGES: {
		CARD_NUM: "Invalid Card Number",
		USER_ID: "Invalid User Id"
	},
	FORM_LABELS: {
		CARD_NUM: "cardNumber",
		USER_ID: "userId",
		VEHICLE_DELINK: "vehicleIUDelink",
		CAPITA_DELINK: "capitaStarId",
		KRISFLYER_DELINK: "krisflyerDelink"
	}
};

export const KrisFlyerDelink = {
	OUTLET_CODE: "ADMINPORTAL",
	PAGE_TITLE: "Krisflyer Delink",
	PAGE_SUBTITLE: "Follow the instructions below to delink Krisflyer ID from CR",
	SEARCH_TITLE: "Enter CR member’s card number or User ID",
	CARD_NUM_PLACEHOLDER: "CR card number e.g 0002001000031201771",
	USER_ID_PLACEHOLDER: "User ID e.g 759273819",
	SEARCH_TEXT: "Search for member ID",
	ACCOUNT_TYPE: "KrisFlyer",
	MEMBER_ID_LABEL: "Krisflyer member ID",
	BUTTON_LABEL: "Delink",
	ALREADY_DELINKED: "Member ID is already delinked!",
	ERROR_MESSAGES: {
		CARD_NUM: "Invalid Card Number",
		USER_ID: "Invalid User Id"
	},
	FORM_LABELS: {
		CARD_NUM: "cardNumber",
		USER_ID: "userId",
		KRISFLYER_DELINK: "krisflyerDelink"
	}
};

export const VehicleIUDelink = {
	PAGE_TITLE: "Vehicle IU Delink",
	PAGE_SUBTITLE: "Follow the instructions below to delink Vehicle IU from CR member",
	ACCOUNT_TYPE: "IU",
	MEMBER_ID_LABEL: "Vehicle IU number"
};

export const ForgotWatchword = {
	CURRENT_WORD_USED_ERR: "You cannot use previous password. Please try again.",
	DISCALIMER_TEXT: "It is time to change your password. To safeguard your account, you are required to change your password now.",
	FP_ERR_WATCHWORD: "Please input your password!",
	FP_WATCHWORD_PLACEHOLDER: "New Password",
	FP_HEADER: "Forgot password?",
	FP_SUBHEADER: "Fill in your Admin ID/ Tenant Code below to request for an email with the instructions on how to set/ change your password.",
	FP_USER_PLACEHOLDER: "Admin ID/Tenant Code",
	FP_SEND_REQ_BTN: "Send request",
	FP_GOBACK_BTN: "Go Back",
	FP_GOTIT_BTN: "Got it!",
	FP_REQ_SENT_HEADER: "Request successfully sent!",
	FP_REQ_SENT_SUBHEADER: "A system generated password has been emailed to the admin. Please note that they are required to change their password upon first login",
	FP_VERIFICATION_CODE_PLACEHOLDER: "Verification Code",
	FP_ERR_INVALID_VERIFICATION_CODE: "You have entered an invalid verification code",
	FP_ERR_INVALID_USERNAME: "You have entered a wrong Admin ID/Tenant Code",
	FP_WATCHWORD_SUCCESS: "Password successfully changed!",
	FP_SOMETHING_WENT_WRONG: "Something went wrong, please try after some time.",
	FP_INVALID_VERIFICATION_CODE: "Invalid verification code provided, please try again."
};

export const DateTimeFormats = {
	USE_AM_PM: "YYYY-MM-DD h:mm A",
	USE_SECONDS: "YYYY-MM-DD HH:mm:ss",
	USE_DD_MMM: "DD MMM, HH:mm",
	USE_YYYY_MM_DD: "YYYY-MM-DD",
	USE_DD_MM_YYYY: "DD-MM-YYYY",
	USE_YYYYMMDD: "YYYYMMDD",
	MOMENT_INVALID_DATE: "Invalid date"
};

export const ADHOC_REPORTS = {
	PAGE_HEADER: "AD-HOC REPORTS",
	SM_LOC_PLACEHOLDER: "SessionM S3 Path (e.g. 6db017c3)",
	SM_LOC_LABEL: "SessionM S3 File Location",
	EXPORT_BUTTON_LABEL: "EXPORT",
	FILE_LOCATION_ERROR: "Incorrect file location. Please enter correct file location.",
	PAGE_SUBHEADER: "",
	NO_DATA_FOUND: "No data found",
	REPORT_GENERATED: "Report is successfully generated!",
	SUCCESS: "File uploaded succesfully",
	SERVER_ERR: "Something went wrong."
};

export const MERGE_CR_ACCOUNTS = {
	SUCCESS: "SUCCESS",
	PAGE_HEADER: "MERGE CR ACCOUNTS",
	PAGE_SUBHEADER: "",
	UID_TO_CANCEL_LABEL: "UID to cancel",
	UID_TO_RETAIN_LABEL: "UID to retain",
	EMAIL_TO_RETAIN_LABEL: "Email to retain",
	UID_TO_CANCEL_PLACEHOLDER: "00000000000000000000000000000000",
	UID_TO_RETAIN_PLACEHOLDER: "00000000000000000000000000000001",
	EMAIL_TO_RETAIN_PLACEHOLDER: "user-to-retain@example.com",

	MERGE_BUTTON_LABEL: "MERGE ACCOUNTS",
	CANCEL_BUTTON_LABEL: "CANCEL ACCOUNT",
	ACCOUNTS_MERGED: "Accounts are merged!",
	SERVER_ERR: "Something went wrong."
};

export const VOID_CR_TRANSACTION = {
	SUCCESS: "SUCCESS",
	PAGE_HEADER: "VOID CR TRANSACTION",
	PAGE_SUBHEADER: "",
	POS_TRANSACTION_ID_LABEL: "POS Transaction ID",
	// OUTLET_CODE - DDMMYY - RECEIPT_NO(replaced "-", truncated to last 25 characters) - CARD_NO(truncated to last 11 digits)
	POS_TRANSACTION_ID_PLACEHOLDER: "OOOOOOOOOOOOO-DDMMYY-REC-CCCCCCCCCCC",
	GET_BUTTON_LABEL: "GET TRANSACTION",
	VOID_BUTTON_LABEL: "VOID",
	BE_SUCCESS: "Transaction has been voided.",
	SERVER_ERR: "Something went wrong."
};

export const CR_POINTS_EXPIRY_SUMMARY = {
	SUCCESS: "SUCCESS",
	PAGE_HEADER: "Check Points Expiry",
	PAGE_SUBHEADER: "Enter a member's Changi Rewards card number or GUID to view the member's points balance and the respective expiry date.",
	EXTERNAL_ID_LABEL: "CR CardNumber / GUID",
	EXTERNAL_ID_LABEL_PLACEHOLDER: "00000000000000000000000000000000",
	GET_BUTTON_LABEL: "GET POINTS BALANCE",
	SERVER_ERR: "Something went wrong.",
	RESULTS_HEADER: "Points Balance",
	WARNING_MESSAGE: "NOTE: Points balance shown on this page are as of yesterday's points balance, and excludes any escrow points.",
	NO_EXPIRING_POINTS: "No points found."
};

export const CR_MEMBERSHIP_STATUS = {
	SUCCESS: "SUCCESS",
	PAGE_HEADER: "Membership Status",
	PAGE_SUBHEADER: "",
	EXTERNAL_ID_LABEL: "CR CardNumber / GUID",
	EXTERNAL_ID_LABEL_PLACEHOLDER: "00000000000000000000000000000000",
	REMARKS_LABEL: "Remarks",
	REMARKS_LABEL_PLACEHOLDER: "",
	FIND_CR_MEMBER_BUTTON_LABEL: "FIND CR MEMBER",
	SUSPEND_BUTTON_LABEL: "SUSPEND",
	UNSUSPEND_BUTTON_LABEL: "UNSUSPEND",
	SERVER_ERR: "Something went wrong."
};
